import AchievementControlPanel from './AchievementControlPanel';

export default AchievementControlPanel;
